import React, { useState, useEffect } from "react";
import { Button, Modal, Input, Select, DatePicker, InputNumber, Form, Radio } from "antd";
import NetworkService from "../services/NetworkService";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useAtom } from "jotai";
import { Link, Location, useLocation, useNavigate } from "react-router-dom";
import CertificateModal from "../components/CertificateModal";
import { accessTokenAtom } from "../atoms";

import { useMsal, useAccount } from "@azure/msal-react";
import { graphrequest, loginRequest } from "../authConfig";

const { TextArea } = Input;

function EditEmailTemplate() {
  const [accessAtom, setAPIAtom] = useAtom(accessTokenAtom);
  const [currentTabTitle, setCurrentTabTitle] = useState("Active CC");
  const [templates, setTemplates] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalDisplay, setModalDisplay] = useState(false);
  const location = useLocation();
  const [state] = useState(location.state);
  const [newValues, setNewValues] = useState([]);
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [accessToken, setAccessToken] = useState();

  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    async function getData() {
      if (account) {
        instance
          .acquireTokenSilent({
            ...loginRequest,
            account: account,
          })
          .then((response) => {
            console.log("CH", response);

            setAccessToken(response.accessToken);
            return response.accessToken;
          })
          .then((token) => {
            const networkServiceObj = new NetworkService();
            networkServiceObj.getCertificateEmailTemplateService(token).then((res) => {
              setCurrentData(res.data);
              setTemplates(res.data);
              setLoading(false);
            });
          });
      }
    }

    setLoading(true);
    getData();
  }, []);

  const handleOk = (values) => {
    let inputBody = {
      id: state.id,
      templateName: values.templateName,
      subject: values.subject,
      bodyFirstParagraph: values.bodyFirstParagraph,
      bodyParagraph2: values.bodyParagraph2,
      bodyParagraph3: values.bodyParagraph3,
      bodyParagraph4: values.bodyParagraph4,
      faceBookUrl: values.faceBookUrl,
      instagramUrl: values.instagramUrl,
      linkedInUrl: values.linkedInUrl,
      footerText: values.footerText,
      footerText2: values.footerText2,
      createdBy: state.createdBy,
      headerImage: state.headerImage,
      logoImage: state.logoImage,
      modifiedBy: accounts[0].name,
      viewCertificateBaseUrl: state.viewCertificateBaseUrl,
      webUrl: state.webUrl,
    };
    const networkServiceObj = new NetworkService();
    networkServiceObj
      .editCertificateEmailTemplateService(inputBody, state.id, accessToken)
      .then((res) => {
        if (res.result.messageCode == 201) {
          navigate("/emailTemplate");
        }
      });
  };

  const previewCert = () => {
    form
      .validateFields()
      .then((values) => {
        setNewValues({ ...values, headerImage: state.headerImage, logoImage: state.logoImage });
      })
      .then(() => {
        setModalDisplay(true);
      });
  };

  return (
    <div
      className="App"
      style={{
        width: "80%",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
        margin: "auto",
      }}
    >
      <Form
        id="retirementForm"
        name="basic"
        form={form}
        labelCol={{ span: 6 }}
        labelAlign={"left"}
        wrapperCol={{
          span: 8,
        }}
        style={{ width: "100%" }}
        onFinish={handleOk}
        onFinishFailed={() => alert("hello")}
        autoComplete="off"
        fields={[
          { name: "templateName", value: state.templateName },
          { name: "subject", value: state.subject },
          { name: "bodyFirstParagraph", value: state.bodyFirstParagraph },
          { name: "bodyParagraph2", value: state.bodyParagraph2 },
          { name: "bodyParagraph3", value: state.bodyParagraph3 },
          { name: "bodyParagraph4", value: state.bodyParagraph4 },
          { name: "faceBookUrl", value: state.faceBookUrl },
          { name: "instagramUrl", value: state.instagramUrl },
          { name: "linkedInUrl", value: state.linkedInUrl },
          { name: "footerText", value: state.footerText },
          { name: "footerText2", value: state.footerText2 },
        ]}
      >
        <Form.Item
          label="Template Name"
          name="templateName"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Template Name is required.",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Subject"
          name="subject"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Subject is required.",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Body First Paragraph"
          name="bodyFirstParagraph"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Body First Paragraph is required.",
            },
          ]}
        >
          <TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Body First Paragraph 2"
          name="bodyParagraph2"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Body First Paragraph 2 is required.",
            },
          ]}
        >
          <TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Body First Paragraph 3"
          name="bodyParagraph3"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Body First Paragraph 3 is required.",
            },
          ]}
        >
          <TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Body First Paragraph 4"
          name="bodyParagraph4"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Body First Paragraph 4 is required.",
            },
          ]}
        >
          <TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Facebook URL"
          name="faceBookUrl"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Facebook URL is required.",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Instagram URL"
          name="instagramUrl"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Instagram URL is required.",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="LinkedIn URL"
          name="linkedInUrl"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "LinkedIn URL is required.",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Footer Text 1"
          name="footerText"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Footer Text 1 is required.",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Footer Text 2"
          name="footerText2"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Footer Text 2 is required.",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ marginRight: 25 }}>
            Submit
          </Button>

          <Link to="/emailTemplate">
            <Button htmlType="button" style={{ marginRight: 25 }}>
              Back
            </Button>
          </Link>

          <Button
            type="link"
            htmlType="button"
            style={{ marginRight: 25 }}
            onClick={() => previewCert()}
          >
            Preview Email Template
          </Button>
        </Form.Item>
      </Form>
      <CertificateModal
        data={newValues}
        display={modalDisplay}
        setDisplay={() => {
          setModalDisplay();
        }}
      />
    </div>
  );
}

export default EditEmailTemplate;
